module.exports = __webpack_public_path__ + "img/Agroalimentario3.b6450ecd.png";